import tw, { styled } from 'twin.macro';

const MarkdownCode = styled.code`
  ${tw`inline px-1 py-0 rounded text-sm font-mono`}

  &:not(pre > &) {
    ${tw`inline text-sm font-normal whitespace-pre-wrap p-1 rounded relative`}
    border: 1px solid ${({ theme }) => theme.warning};
    background-color: rgb(255 255 255 / 1);
    font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;
  }
`;

export default MarkdownCode;